const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="text-center text-sm text-gray-500 py-4 flex items-end h-full justify-center">
      ©{currentYear} All Rights Reserved
    </footer>
  );
};

export default Footer;
